import { IconFn, IconSvg } from "../createIcon";

export const ErrorSolidIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 40 }} {...props}>
    <g clipPath="url(#clip0_1613_12670)">
      <path
        d="M22.842 1.27578C22.1212 -0.0867188 19.8795 -0.0867188 19.1587 1.27578L0.408654 36.6924C0.23987 37.0099 0.156194 37.3656 0.165779 37.725C0.175364 38.0844 0.277884 38.4352 0.463349 38.7432C0.648814 39.0512 0.910898 39.3059 1.22407 39.4824C1.53723 39.659 1.8908 39.7515 2.25032 39.7508H39.7503C40.1096 39.7515 40.4629 39.6592 40.7759 39.4827C41.0888 39.3062 41.3507 39.0517 41.536 38.7438C41.7213 38.436 41.8236 38.0854 41.8331 37.7263C41.8425 37.3671 41.7587 37.0117 41.5899 36.6945L22.842 1.27578ZM23.0837 33.5008H18.917V29.3341H23.0837V33.5008ZM18.917 25.1674V14.7508H23.0837L23.0857 25.1674H18.917Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1613_12670">
        <rect width={42} height={40} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
